var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Distributor in Korea",
      "tabActive": "ENDO Metal-Sleeve",
      "bg": "/images/sub/visual/sv3.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit mb-lg-42"
  }, [_vm._v(" ENDO Metal-Sleeve ")])]), _c('sub-bg-image', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-top-img.png",
      "className": "h-lg-340px"
    }
  }, [_c('h3', {
    staticClass: "tit font-weight-semibold mb-8 mb-md-50 mb-lg-100"
  }, [_vm._v(" ENDO 제작소의 MetalSleeve는 "), _c('br'), _vm._v(" 독자적으로 개발한 금속 소성가공기술을 "), _c('br'), _vm._v(" 적용한 Metal Sleeve입니다. ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-2 mb-lg-10"
  }, [_vm._v(" Metal Sleeve는 엔도 제작소의 금속 소성 가공 기술의 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 진화에 의해 탄생 하였습니다. ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-2 mb-lg-10"
  }, [_vm._v(" 연구를 거듭해 개발한 Metal Sleeve는 10μm 정도의 초박육 설계로, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 이음매가 없는 금속 가공하여, 고성능의 OA 기기에는 꼭 필요한 부품으로 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 큰 점유율을 차지하고 있습니다. ")]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" 환경산업과 의료산업 등 향후 성장이 기대되는 분야로 시야를 넓혀 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 독자적인 기술로 확실한 가치와 상품을 제공해 나갈 것입니다. ")])])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "특장점"
    }
  }, [_c('v-row', [_c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/endo/endo-icon1.png",
      "iconWidth": "50",
      "num": "01"
    }
  }, [_vm._v(" 높은기술력은 정밀한 품질이 요구되는 제품의 고도화에 극대화 ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/endo/endo-icon2.png",
      "iconWidth": "50",
      "num": "02"
    }
  }, [_vm._v(" 고품질을 유지하면서 대량생산을 가능하게 하는 생산체제를 확립 ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/endo/endo-icon3.png",
      "iconWidth": "50",
      "num": "03"
    }
  }, [_vm._v(" 기술과 품질은 다양한업계에서 주목을 받고 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 큰 잠재력을 가지고 있습니다. ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/endo/endo-icon4.png",
      "iconWidth": "50",
      "num": "04"
    }
  }, [_vm._v(" 초박육의이음매가 없는 금속 가공을 가능하게 해, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 고성능의 OA 기기에는 꼭 필요한 기능 부품 ")])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "ENDO Metal-Sleeve",
      "className": "full"
    }
  }, [_c('v-row', {
    staticClass: "my-n10 my-lg-n40"
  }, [_c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "4"
    }
  }, [_c('image-detail', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-img3-1.png"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-medium"
  }, [_vm._v(" Ultra-Thin Seamless Pipe ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail"
  }, [_vm._v(" 판 두께 40μm 이하의 초박육 가공을 실현함으로써, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 수지필름과 같이 슬리브를 구부려 사용하는것이 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 가능해집니다. 내열성, 내식성, 내마모성, 강성이 우수합니다. ")]), _c('standard', {
    attrs: {
      "diameter": "φ18mm에서 φ45mm까지",
      "weight": "27μm에서 100μm까지",
      "length": "420mm까지"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "4"
    }
  }, [_c('image-detail', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-img3-2.png"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-medium"
  }, [_vm._v(" Thin Seamless Pipe ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail"
  }, [_vm._v(" 타공법에서는 실현 곤란한 판 두께 100μm 이하의 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 얇은 가공을 실현, 내열 강도나 내식성을 갖춘 얇은 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 이음매 없는 파이프로서 사용하고 있습니다. ")]), _c('standard', {
    attrs: {
      "diameter": "φ10mm에서 φ30mm까지",
      "weight": "100μm에서 300μm까지",
      "length": "420mm까지"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "4"
    }
  }, [_c('image-detail', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-img3-3.png"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-medium"
  }, [_vm._v(" Ultra-Thin Seamless Belt ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail"
  }, [_vm._v(" 내열성, 내식성이 우수하고, 또한 피로 강도를 향상시키는 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 처방을 실시함으로써 구동 전달용 벨트의 기재로서 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 우수한 특성을 나타내고 있습니다. ")]), _c('standard', {
    attrs: {
      "diameter": "φ20mm에서 φ160mm까지",
      "weight": "15μm에서 60μm까지",
      "length": "3mm에서 400mm까지"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "4"
    }
  }, [_c('image-detail', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-img3-4.png"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-medium"
  }, [_vm._v(" Small Diameter, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" Ultra-Thin Seamless Ring ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail"
  }, [_vm._v(" 소경・박육 용도로의 심리스 링이 됩니다. "), _c('br'), _vm._v(" 최소 직경으로 φ3, 최소 두께로 t15μm를 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 실현하고 있어 의료 기기의 부품으로서 검토 되고 있습니다. ")]), _c('standard', {
    attrs: {
      "diameter": "φ3mm에서 φ30mm까지",
      "weight": "15μm에서 60μm까지",
      "length": "3mm에서"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "4"
    }
  }, [_c('image-detail', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-img3-5.png"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-medium"
  }, [_vm._v(" Small Diamete, Ultra-Thin "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" Seamless Pipe ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail"
  }, [_vm._v(" 소경・박육 용도로의 이음매없는 파이프가 됩니다. "), _c('br'), _vm._v(" 최소 직경으로 φ3, 최소 두께로 t15μm를 실현하고 있어 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 전기기기, 의료 기기, 자동차의 부품으로서 검토 되고 있습니다. ")]), _c('standard', {
    attrs: {
      "diameter": "φ3mm에서 φ10mm까지",
      "weight": "15μm에서 100μm까지",
      "length": "400mm까지"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "4"
    }
  }, [_c('image-detail', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-img3-6.png"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-medium"
  }, [_vm._v(" Seamless Case "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" with Bottom ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-16 mb-lg-34 endo-item-detail"
  }, [_vm._v(" 바닥부・원통부에 용접부가 없기 때문에 내식성이 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 우수하고, 엄격한 사용 환경에 있어서 뛰어난 특성을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 건전지 케이스로 제작될 만큼 활용도가 넓습니다. ")]), _c('standard', {
    attrs: {
      "diameter": "φ20mm에서 φ60mm까지",
      "weight": "50μm에서 300μm까지",
      "length": "50mm에서 400mm까지"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('inquiry', {
    attrs: {
      "src": "/images/sub/distributor/endo/endo-img1.png",
      "name": "황 정호",
      "tel": "031-765-2268",
      "mail": "hwangjoe@ist-co.kr",
      "fax": "031-765-2389",
      "link": "http://endo-mfg.co.jp/eng/",
      "linkBg": "/images/sub/distributor/endo/endo-img2.png"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }